import { Component } from '@angular/core';

@Component({
  selector: 'adb-app-offline',
  imports: [],
  templateUrl: './app-offline.html',
  styleUrl: './app-offline.scss',
})
export class AppOffline {
  retry(): void {
    this.reloadPage();
  }

  protected reloadPage(): void {
    window.location.reload();
  }
}
